<template>
<!--    交付表-->
    <div class="rf">
        <el-form  :model="formData" :rules="formRules" ref="formRef" label-width="80px">
            <div class="formDiv">
                <el-form-item class="form-title num" prop="num" label="No:" >
                    <span  v-model="formData.num" style="color:#b3d268;font-size: 16px;font-style: italic;width: 150px;">{{formData.num}}</span>
                </el-form-item>
                <div class="item">
                    <el-form-item class="form-title" prop="wtname" :label="$t('form_entrust_company')" >
                        <el-input  v-model="formData.wtname" disabled>
                        </el-input>
                    </el-form-item>
                    <el-form-item class="form-title" prop="gsname" :label="$t('promanagement_processing_unit')" >
                        <el-input  v-model="formData.gsname" disabled>
                        </el-input>
                    </el-form-item>
                    <el-form-item class="form-title" prop="bmname" :label="$t('promanagement_processing_department')" >
                        <el-input  v-model="formData.bmname" disabled>
                        </el-input>
                    </el-form-item>
                    <el-form-item class="form-title" prop="ckname" :label="$t('form_warehouse')" >
                        <el-input  v-model="formData.ckname" disabled>
                        </el-input>
                    </el-form-item>
                </div>
                <div class="item">
                    <el-form-item class="form-title" prop="ccpro" :label="$t('form_finished_goods')" >
                        <el-input  v-model="formData.ccpro" disabled>
                        </el-input>
                    </el-form-item>
                    <el-form-item class="form-title" prop="pcnum" :label="$t('form_batch_number')" >
                        <el-input  v-model="formData.pcnum" disabled>
                        </el-input>
                    </el-form-item>
                    <el-form-item class="form-title" prop="jfnum" :label="$t('form_delivery_quantity')" >
                        <el-input  v-model="formData.jfnum" disabled>
                        </el-input>
                    </el-form-item>
                    <el-form-item class="form-title" prop="jgcost" label="加工费" >
                        <el-input  v-model.number="formData.jgcost" disabled>
                        </el-input>
                    </el-form-item>
                </div>
            </div>
            <div style="margin-bottom: 20px">
                <el-table
                        size="mini"
                        border
                        ref="multipleTable"
                        :data="tableData"
                        height="441"
                        :row-class-name="tableRowClassName"
                        tooltip-effect="dark"
                        style="width: 100%;">
                    <el-table-column
                            :label="$t('form_serial_number')"
                            align="left"
                            type="index"
                            width="55">
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="vc_hqgsname"
                            :label="$t('form_goods_rights_company')"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="vc_pzname"
                            :label="$t('form_product_name')"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="vc_no"
                            :label="$t('form_batch_number')"
                    width="200"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="vc_unit"
                            :label="$t('form_metering')"
                            width="80"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="f_require"
                            label="单吨需求"
                            width="100"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="f_innum"
                            :label="$t('promanagement_consume')"
                            width="100"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="dl"
                            label="得率"
                            width="100"
                            show-overflow-tooltip>
                    </el-table-column>

                </el-table>
            </div>
            <el-form-item class="form-title" prop="vc_note" :label="$t('form_notes')" >
                <el-input  v-model="formData.vc_note" disabled>
                </el-input>
            </el-form-item>
            <div class="formDiv flex">
                <el-form-item class="form-title" prop="vc_lruname" :label="$t('form_creator')" >
                    <el-input  v-model="formData.vc_lruname" disabled>
                    </el-input>
                </el-form-item>
                <el-form-item class="form-title" prop="date" :label="$t('form_date')" >
                    <el-input  v-model="formData.date" disabled>
                    </el-input>
                </el-form-item>
            </div>
        </el-form>
        <div slot="footer" v-if="edit==false" class="dialog-footer" style="text-align: center">

            <el-button type="success" @click="renderForm" >交付</el-button>
            <el-button @click="cancel">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    // import * as API from "./../api"
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "RenderForm",
        props:{
            render:{
                type:Object,
                required: true,
            }
        },
        data() {
            return {
                edit:false,
                jgcost:"",
                formData:{
                    gsname:"",
                    bmname:"",
                    jgcost:"",
                    wtname:"",
                    pcnum:"",
                    jfnum:"",
                    ccpro:"",
                    ckname:"",
                    num:"000000",
                    vc_note:"",
                    vc_lruname: sessionStorage.getItem("lruname"),
                    date:"",
                    tableData:[],
                },
                formRules:{
                    jgcost:[{required:true,message:"请输入加工费",trigger:"blur"}],
                },
                tableData:[],
                disabled:false,
                baseerp:"",
                i_id:0,
                f_outnum:0,
                i_outid:0,
                form:{},
                mid:0,
            }
        },
        mounted() {
            this.baseerp=baseerp;
            this.title=this.render.title;
            this.form=this.render.value;
            this.assignment();
        },
        methods: {
            //赋值
            assignment(){
                this.i_outid=this.form.i_outid;
                this.i_id=this.form.i_id;
               /* this.f_outnum=this.form.f_outnum;
                this.formData={
                    gsname:this.form.vc_outgsname,
                    bmname:this.form.vc_gname,
                    jgcost:this.form.f_jgmoney,
                    wtname:this.form.vc_ingsname,
                    pcnum:this.form.vc_no,
                    jfnum:this.form.f_outnum,
                    ccpro:this.form.vc_pzname,
                    ckname:this.form.vc_ckname,
                    num:this.form.i_outid,
                    vc_note:this.form.vc_jfnote,
                    vc_lruname:"zyh",
                    date:this.form.dt_lrcreatetime,
                };*/
                if (this.title=="查看交付单"){
                    this.getProduceOdd();
                    this.edit=true
                    this.disabled=true;
                }else if (this.title=="提交交付单"){
                    this.getProduceOdd();
                    //this.getConsumeList();
                    this.edit=false;
                    this.disabled=false;
                }
                //this.getConsumeList();
            },
            //查看
            async getProduceOdd(){
                let param={
                    i_id:this.i_id,
                    i_outid:this.i_outid,
                    i_mid: this.mid,
                }
                let res=await API.getProduceOdd(param);
                if(res.code==1){
                    this.formData={
                        gsname:res.data.vc_outgsname,
                        bmname:res.data.vc_gname,
                        jgcost:res.data.f_jgmoney,
                        wtname:res.data.vc_ingsname,
                        pcnum:res.data.vc_no,
                        jfnum:res.data.f_num,
                        ccpro:res.data.vc_pzname,
                        ckname:res.data.vc_ckname,
                        num:res.data.i_outid,
                        vc_note:res.data.vc_jfnote,
                        vc_lruname:res.data.vc_lruname,
                        date:res.data.dt_createtime,
                    };
                    this.tableData=res.data.details;
                    this.formData.tableData=res.data.details;
                    //this.$message.success(res.message);
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }

            },
            renderForm(){},

            tableRowClassName({row,rowIndex}){
                //console.log(row.i_gsid,this.gsid)
                if(row.i_gsid!=this.gsid){
                    return 'danger-row';
                }
            },
            cancel(){
                //console.log(this.pageSize,"------")
                this.$emit('close');

                //this.$emit('getEntrustCompanyHaveList')
            },
        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        display: flex;
    }
    .item{
        width: 100%;
    }
    /deep/{
        .num{
            margin-bottom: 12px;
        }
        .num .el-form-item__label {
            color: #b3d268;
            font-size: 16px;
            font-style: italic;
        }
        .num .el-form-item__content {
            width: 130px;
        }
        .danger-row{
            color: #999;
        }
    }
</style>